import React, { Component, useState } from 'react'
import moment from 'moment'
import CalenderHelperClass from '@/helpers/CalenderHelper'

import {SelectInterval} from './view/SelectInterval';

export class IntervalSetting extends Component<any> {
    constructor(props:any) {
        super(props);
    }    
    
    render() {
        
        
        return (
            <div>
                <SelectInterval />
            </div>
        )    
    }

}